module.exports = __webpack_public_path__ + "assets/07b552ad0bf5985f4624e19b43a46caa.mp3";